import { render } from "./ModalContent.vue?vue&type=template&id=9f83d368"
import script from "./ModalContent.vue?vue&type=script&lang=js"
export * from "./ModalContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ModalContent.vue"]])

export default __exports__